import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import "./DonationSuccess.css";

const DonationSuccess = () => {
    const [searchParams] = useSearchParams();

    const sessionId = searchParams.get("session_id");

    return (
        <main className="donation-success-page">

            <div className="donation-success-card">

                <div className="success-icon">
                    ✓
                </div>

                <div className="success-eyebrow">
                    THANK YOU
                </div>

                <h1>
                    Your Donation Was Successful
                </h1>

                <p className="success-message">
                    Thank you for supporting STEMX365.
                    Your contribution helps us provide
                    students with opportunities in STEM,
                    robotics, space science, and
                    space technology education.
                </p>

                <div className="success-divider"></div>

                <p className="receipt-message">
                    A confirmation and receipt will be
                    sent to the email address you provided
                    during checkout.
                </p>

                {sessionId && (
                    <div className="session-info">
                        <span>Transaction Reference</span>

                        <code>
                            {sessionId}
                        </code>
                    </div>
                )}

                <Link
                    to="/"
                    className="success-home-button"
                >
                    Return to STEMX365
                </Link>

            </div>

        </main>
    );
};

export default DonationSuccess;